import { SHOW_AREA_FEATURE_TO_CLIENT } from '@globalConstants';
import useAreasByCustomer from '../useAreasByCustomer';
import useCustomerId from '../useCustomerId';
import useRemoteConfig from '../useRemoteConfig';
import useUser from '../useUser';
/**
 *  useShowAreaFeature is a hook which returns a boolean that indicates true if the user should see area features
 */
const useShowAreaFeature = () => {
  const { user } = useUser();
  const { customerId } = useCustomerId();
  const { data: areas } = useAreasByCustomer({
    customerId,
    allowRequest: !user?.isInternal,
  });
  const { remoteConfigState } = useRemoteConfig();

  if (user?.isInternal) {
    return { showAreaFeature: true };
  } else if (!remoteConfigState[SHOW_AREA_FEATURE_TO_CLIENT]) {
    return { showAreaFeature: false };
  }
  const customerHasAreas = areas?.length > 0;
  return { showAreaFeature: customerHasAreas };
};
export default useShowAreaFeature;
